import { apiFetch, readErrorMessage, readJson } from './client';
import { asMyAppsState } from './myAppsState';

export { asExternalApp, asMyAppsState } from './myAppsState';

export interface MyAppsCatalogItem {
  id: string;
  title: string;
  description: string;
  category: string;
  minRole: string;
  enabled: boolean;
  defaultEnabled: boolean;
}

export interface MyAppsExternalApp {
  id: string;
  title: string;
  description: string;
  category: string;
  icon: string;
  path: string;
  url: string;
  kind: string;
}

export interface MyAppsState {
  catalog: MyAppsCatalogItem[];
  enabledAppIds: string[];
  pinnedToolIds: string[];
  recentToolIds: string[];
  externalApps: MyAppsExternalApp[];
}

export interface MyAppsUpdateRequest {
  enabledAppIds?: string[];
  pinnedToolIds?: string[];
  recentToolIds?: string[];
}

export async function fetchMyAppsState(): Promise<MyAppsState> {
  const res = await apiFetch('/api/apps/my-apps');
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return asMyAppsState(await readJson<unknown>(res));
}

export async function updateMyAppsEnabled(enabledAppIds: string[]): Promise<MyAppsState> {
  return updateMyAppsPreferences({ enabledAppIds });
}

export async function updateMyAppsPreferences(
  request: MyAppsUpdateRequest
): Promise<MyAppsState> {
  const res = await apiFetch('/api/apps/my-apps', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return asMyAppsState(await readJson<unknown>(res));
}
